<ng-container *ngIf="subAreasOptions?.length > 9">
    <mat-checkbox
      [checked]="allSelect"
      (change)="selectAll($event)"
      *ngIf="checkBoxAll"
      class="ps-2"
    >
      <span [ngClass]="{ 'fw-bold': boldSelectAll }">{{
        allPhase
      }}</span></mat-checkbox
    >
</ng-container>

<ng-container *ngIf="subAreasOptions?.length <= 9">
  <div
    class="form-checkbox-list check-app"
  >
    <mat-checkbox
      [checked]="allSelect"
      (change)="selectAll($event)"
      *ngIf="checkBoxAll"
      class="ps-2"
    >
      <span [ngClass]="{ 'fw-bold': boldSelectAll }">{{
        allPhase
      }}</span></mat-checkbox
    >

    <div *ngFor="let subArea of subAreasOptions">
      <div *ngIf="(hideSelected && !subArea.checked) || !hideSelected">
        <div *ngIf="(onlySelected && subArea.checked) || !onlySelected">
          <label
            [ngClass]="{
              'ps-2': !subArea.separator
            }"
            class="mb-0 white-space-no-wrap"
            *ngIf="!subArea.hidden"
          >
            <span *ngIf="subArea.separator" class="custom-checkbox-separator">{{
              subArea.option
            }}</span>
            <mat-checkbox
              *ngIf="!subArea.separator && !onlyView"
              [(checked)]="subArea.checked"
              (change)="selectOne(subArea, $event)"
              >{{ label(subArea) }}</mat-checkbox
            >
            <span *ngIf="!subArea.separator"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-container>

